import request from 'utils/request';

export default {
  accounts: async (data) => await request.post('/search/accounts', data),
  contacts: async (data) => await request.post('/search/contacts', data),
  quotes: async (data) => await request.post('/search/quotes', data),
  quoteItems: async (data) => await request.post('/search/quote_items', data),
  orders: async (data) => await request.post('/search/orders', data),
  orderItems: async (data) => await request.post('/search/order_items', data),
  parts: async (data) => await request.post('/search/parts', data),
  shares: async (data) => await request.post('/search/shared_with_me', data),
};
